import React, { useEffect } from "react";
import "./styles.scss";
import "./mobile.scss";
import { ActionIcon } from "../../../components";
import { Dropdown, Menu } from "antd";

import { RiArrowDropDownLine } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ntbLogo } from "../../../assets/img";
import { getDocumentsByClassFilter } from "../../../modules/console/services/console.service";
import consoleReducer from "../../../modules/console/redux/console.reducer";
import darazLogo from "../../../assets/img/daraz-logo.png";
import Theme from "../../../constants/theme";

const ConsoleHeader = (props) => {
  const theme = sessionStorage.getItem(Theme.KEY);

  const dispatch = useDispatch();

  const { requestId } = useSelector(({ loginReducer }) => loginReducer);
  const { existingCusDetails, profileImgURL } = useSelector(({ consoleReducer }) => consoleReducer);

  const fetchProfilePicture = async () => {
    const response = await getDocumentsByClassFilter({
      DocumentClass: "AVR_Doc",
      FilterString: `[App_BatchId] = 'DSO_Profile_Pic' AND ([App_DocType] = 'CP') AND [App_ref_no] ='${existingCusDetails?.profile?.CustomerId}' AND [App_Sts] <> 'D'`,
      Properties: [
        {
          Id: "App_BatchId",
          Value: "Batch ID",
        },
        {
          Id: "App_User",
          Value: "App_User",
        },
      ],
      CreatedUserPropertyName: {
        Id: "App_User",
        Value: "Created User",
      },
      CreatedDatePropertyName: {
        Id: "DateCreated",
        Value: "DateCreated",
      },
      SubjectPropertyName: {
        Id: "DocumentTitle",
        Value: "DocumentTitle",
      },
    });
    if (response.docList.length > 0)
      dispatch(
        consoleReducer.actions.setProfileImgURL(
          `data:${response.docList[0]?.MIMEType};base64, ${response.docList[0]?.Thumbnail}`,
        ),
      );
  };

  useEffect(() => {
    fetchProfilePicture().catch(console.error);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const menu = (
    <Menu>
      <Menu.Item>
        <Link to={"/"}>Logout</Link>
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <section className={`console-header-wrapper d-flex align-items-center justify-content-between`}>
        {/*profile header */}
        <div className={"c-header-content d-flex align-items-center"}>
          <div className={"c-header-profile d-flex justify-content-between"}>
            {theme ? (
              <div className="logo-img-wrapper">
                <img
                  className="animate_animated animate_fadeInDown daraz-logo"
                  src={darazLogo}
                  alt="Daraz online banking"
                />

                <img className="animate_animated animate_fadeInDown mh-logo" src={ntbLogo} alt="NTB online banking" />
              </div>
            ) : (
              <img className="animate_animated animate_fadeInDown mh-logo" src={ntbLogo} alt="NTB online banking" />
            )}
          </div>
        </div>

        <div className={"help-text-wrapper   d-flex animate__animated animate__fadeInDown"}>
          <div className={"need-help"}> Need Help ?</div>
          <a
            href="https://www.nationstrust.com/nations-direct-self-onboarding-platform-new"
            target="_blank"
            rel="noreferrer noopener"
          >
            <div className={"check-out"}>Check out FAQ</div>
          </a>
        </div>

        <div className={"c-header-action-menu d-flex"}>
          <div className={"profile-detail-wrp d-flex align-items-center "}>
            <div className={`profile-avatar animate__animated animate__fadeInDown ${props.img ? "" : "empty-img"}`}>
              <img className={"animate__animated animate__fadeIn"} src={profileImgURL} alt="NTB online banking" />
            </div>
            <div className={"profile-details-content d-flex"}>
              <div className={"d-flex  flex-column"}>
                <div className={"profile-greeting animate__animated animate__fadeInDown"}>Reference no</div>
                <div className={"profile-name animate__animated animate__fadeInUp"}>{requestId}</div>
              </div>
              <Dropdown overlay={menu} placement="bottomLeft">
                <div className={"drop-icon-wrapper"} onClick={(e) => e.preventDefault()}>
                  <ActionIcon size={"sm"} icon={<RiArrowDropDownLine />} />
                </div>
              </Dropdown>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ConsoleHeader;
